/* eslint-disable ember/no-controller-access-in-routes */
import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { isEmpty } from '@ember/utils';

export default class IndexRoute extends Route {
  @service
  router;

  afterModel() {
    // Redirect the user to the first subject in the list.
    let controller = this.controllerFor('group/triangulation');
    if (!isEmpty(controller) && !isEmpty(controller.subjects)) {
      let subject = controller.subjects[0];
      if (!isEmpty(subject)) {
        this.router.transitionTo('group.triangulation.subject', subject.id);
      }
    }
  }
}
